<template>
	<div class="detail">
		<dyTab v-if="isDy" />
		<ksTab v-else />
	</div>
</template>
<script>
import dyTab from './dyTab.vue';
import ksTab from './ksTab.vue';
import { PLATFORM_DY } from '@/utils/dataMap';
export default {
	name: 'detail',
	components: {
		dyTab,
		ksTab,
	},
	computed: {
		isDy() {
			let platformId = this.$route.query.platformId || PLATFORM_DY.value;
			return +platformId === +PLATFORM_DY.value;
		},
	},
	data() {
		return {};
	},
};
</script>
<style lang="less" scoped>
</style>
